export function mapShape(shape) {
  if (!shape) {
    return {
      shape: "",
      dimensions: {},
    };
  }

  const shapeType = shape.type.toLowerCase();

  const dimensions = shape.dimensions
    ? {
        d: shape.dimensions.diameter,
        h: shape.dimensions.height,
        c: shape.dimensions.diagonal,
        t1: shape.dimensions.thickness,
        t2: shapeType === "round" && !shape.convex ? shape.dimensions.thickness : shape.dimensions.thickness2,
        w1: shape.dimensions.width,
        w2: shapeType === "oval" && !shape.convex ? shape.dimensions.width : shape.dimensions.width2,
      }
    : {};

  return {
    shape: shapeType,
    dimensions,
  };
}

export function mapPillToShape(pill) {
  const dimensions = {};
  if (pill.shape === "capsule") {
    dimensions["height"] = pill.properties.h;
    dimensions["diameter"] = pill.properties.d;
  } else if (pill.shape === "egg") {
    dimensions["height"] = pill.properties.h;
    dimensions["diameter"] = pill.properties.d;
  } else if (pill.shape === "ball") {
    dimensions["diameter"] = pill.properties.d;
  } else if (pill.shape === "round") {
    dimensions["diameter"] = pill.properties.d;
    dimensions["thickness"] = pill.properties.t1;
    if (pill.isConvex) {
      dimensions["thickness2"] = pill.properties.t2;
    }
  } else if (pill.shape === "oval") {
    dimensions["height"] = pill.properties.h;
    dimensions["width"] = pill.properties.w1;
    if (pill.isConvex) {
      dimensions["width2"] = pill.properties.w2;
    }
    dimensions["thickness"] = pill.properties.t1;
    dimensions["thickness2"] = pill.properties.t2;
    dimensions["diagonal"] = pill.properties.c;
  }

  return {
    type: pill.shape.toUpperCase(),
    convex: pill.isConvex,
    dimensions,
  };
}
